import HTTP from '@/api/HTTP';
import transformer from '@/services/logistique/ordreTravail/impression/dataTransformer';

const URL_BASE = 'gescom/OrdreTravailImpression/';

export default async function getAll(serverTabledata) {
  const inputServer = transformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function getAllResume(serverTabledata) {
  const inputServer = transformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllOtImpressionResumeAsync', inputServer);
  return response;
}

export async function prendreEnCharge(data) {
  const response = await HTTP.post(URL_BASE + 'PrendreEnChargeAsync', data);
  return response;
}
